import Instruction from "./instruction";

export default Instruction;
